import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebase-config';

type Pattern = 'cvc_short_vowels' | 'digraphs' | 'magic_e' | 'consonant_blends' | 'vowel_teams' | 'r_controlled';

export class PatternSelector {
  private static readonly ROTATION = ['cvc_short_vowels', 'digraphs', 'magic_e', 'consonant_blends', 'vowel_teams', 'r_controlled'] as Pattern[];

  static async getNextPattern(childId: string): Promise<Pattern> {
    try {
      const progressRef = doc(db, 'child_progress', childId);
      const progressDoc = await getDoc(progressRef);
      
      if (!progressDoc.exists()) {
        // First time - start with CVC
        await this.saveLastPattern(childId, 'cvc_short_vowels');
        return 'cvc_short_vowels';
      }

      const data = progressDoc.data();
      const lastPattern = data.patternProgress?.lastPattern as Pattern | undefined;

      if (!lastPattern) {
        await this.saveLastPattern(childId, 'cvc_short_vowels');
        return 'cvc_short_vowels';
      }

      // Get next in rotation
      const currentIndex = this.ROTATION.indexOf(lastPattern);
      const nextIndex = (currentIndex + 1) % this.ROTATION.length;
      console.log(`🔄 Pattern rotation: ${lastPattern} → ${this.ROTATION[nextIndex]}`);
      const nextPattern = this.ROTATION[nextIndex];

      await this.saveLastPattern(childId, nextPattern);
      return nextPattern;
      
    } catch (error) {
      console.error('Pattern selection error:', error);
      return 'cvc_short_vowels'; // Safe fallback
    }
  }

  private static async saveLastPattern(childId: string, pattern: Pattern): Promise<void> {
    const progressRef = doc(db, 'child_progress', childId);
    
    await setDoc(progressRef, {
      patternProgress: {
        lastPattern: pattern,
        lastUpdated: new Date().toISOString()
      }
    }, { merge: true });
  }
}